import * as React from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";

import "./Banner.scss";

interface BannerProps {
    pageTitle?: string;
    logo: string;
    href: string;
    title: string;
    altText: string;
}

export const Banner = ({ pageTitle, logo, href, title, altText } : BannerProps) => {

    const renderLogo = () => {
        if(href && href.trim() !== "") {
            return <a href={href} title={title}><Image alt={altText} src={logo} height={73}/></a>
        } else {
            return <Image src={logo} alt= {altText} height={73}/>
        }
    }

    return (
        <section className="banner">
            <Container fluid>
                <Row>
                    <Col xs={{ span: 12, order: 2 }} sm={{ span: 4, order: 1 }}>
                        <div className="title">
                            {pageTitle}
                        </div>
                    </Col>
                    <Col xs={{ span: 12, order: 1 }} sm={{ span: 4, order: 2 }}>
                        {renderLogo()}
                    </Col>
                    <Col xs={{ span: 12, order: 3 }} sm={{ span: 4, order: 3 }}></Col>
                </Row>
            </Container>
        </section>
    );

}
